"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Select = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/Select"));

var _OptionGroup = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/OptionGroup"));

var _PickList = _interopRequireDefault(require("@icare/forms/lib/components/PickList"));

var _MultiPickList = _interopRequireDefault(require("../MultiPickList"));

var _Button = _interopRequireDefault(require("../Button"));

var _FilterDropdown = _interopRequireDefault(require("./FilterDropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The FilterPanel component
 */
var FilterPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterPanel, _React$Component);

  var _super = _createSuper(FilterPanel);

  function FilterPanel(props) {
    var _this;

    _classCallCheck(this, FilterPanel);

    _this = _super.call(this, props);
    _this.state = {
      filterValues: props.filterValues || {},
      sortBy: props.sortBy || null,
      selectedOption: '',
      multiSelectValues: []
    };
    _this.filterDropdownRef = null;
    _this.sortDropdownRef = null;
    _this.handleApplySort = _this.handleApplySort.bind(_assertThisInitialized(_this));
    _this.handleSortChange = _this.handleSortChange.bind(_assertThisInitialized(_this));
    _this.handleApplyFilters = _this.handleApplyFilters.bind(_assertThisInitialized(_this));
    _this.handleClearFilters = _this.handleClearFilters.bind(_assertThisInitialized(_this));
    _this.handleFilterChange = _this.handleFilterChange.bind(_assertThisInitialized(_this));
    _this.handleMultiChange = _this.handleMultiChange.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(FilterPanel, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.filterValues !== nextProps.filterValues) {
        this.setState({
          filterValues: nextProps.filterValues || {}
        });
      }

      if (this.state.sortBy !== nextProps.sortBy) {
        this.setState({
          sortBy: nextProps.sortBy
        });
      }
    }
  }, {
    key: "handleApplySort",
    value: function handleApplySort(e) {
      e.preventDefault();
      this.sortDropdownRef.closePanel();
      this.props.onApplySort(this.state.sortBy);
    }
  }, {
    key: "handleSortChange",
    value: function handleSortChange(e) {
      e.preventDefault();
      this.setState({
        sortBy: e.target.value
      });
    }
  }, {
    key: "handleClearFilters",
    value: function handleClearFilters(e) {
      e.preventDefault();
      this.setState({
        filterValues: {},
        multiSelectValues: []
      });
      this.filterDropdownRef.closePanel();
      this.props.onClearFilters();
    }
  }, {
    key: "handleApplyFilters",
    value: function handleApplyFilters(e) {
      e.preventDefault();
      this.filterDropdownRef.closePanel();
      this.props.onApplyFilters(this.state.filterValues);
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(id, value) {
      this.setState(function (prevState) {
        return {
          filterValues: _objectSpread(_objectSpread({}, prevState.filterValues), {}, _defineProperty({}, "".concat(id), value))
        };
      });
    }
  }, {
    key: "handleMultiChange",
    value: function handleMultiChange(id, obj) {
      var result = [];

      if (obj && obj.length) {
        result = obj.map(function (a) {
          return a.value;
        });
      }

      this.setState(function (prevState) {
        return {
          filterValues: _objectSpread(_objectSpread({}, prevState.filterValues), {}, _defineProperty({}, "".concat(id), result)),
          multiSelectValues: obj
        };
      });
    }
  }, {
    key: "_checkValueType",
    value: function _checkValueType(value) {
      if (typeof value === 'string') {
        return parseInt(value);
      }

      if (value) {
        return value;
      }

      return '';
    }
  }, {
    key: "_checkRadioValueType",
    value: function _checkRadioValueType(value) {
      if (value) {
        return value;
      }

      return '';
    }
  }, {
    key: "_renderFilterField",
    value: function _renderFilterField(filter) {
      var _this2 = this;

      switch (filter.type) {
        case 'radio':
          return /*#__PURE__*/_react.default.createElement(_OptionGroup.default, {
            className: "fd__field",
            key: filter.id,
            name: filter.id,
            type: filter.type,
            label: filter.title || filter.label,
            options: filter.options,
            value: this._checkRadioValueType(this.state.filterValues[filter.id]),
            onChange: function onChange(value) {
              _this2.handleFilterChange(filter.id, value);
            }
          });

        case 'checkbox':
          return /*#__PURE__*/_react.default.createElement(_OptionGroup.default, {
            className: "fd__field",
            key: filter.id,
            name: filter.id,
            type: filter.type,
            label: filter.title || filter.label,
            options: filter.options,
            value: this._checkValueType(this.state.filterValues[filter.id]),
            onChange: function onChange(value) {
              _this2.handleFilterChange(filter.id, value);
            }
          });

        case 'picklist':
          return /*#__PURE__*/_react.default.createElement("div", {
            key: filter.id,
            className: "fd__field"
          }, /*#__PURE__*/_react.default.createElement(_PickList.default, {
            name: filter.id,
            label: filter.title || filter.label,
            listOptions: filter.options,
            filterFunc: function filterFunc(options, filterStr) {
              return options.filter(function (option) {
                return option.label.toLowerCase().includes(filterStr.toLowerCase());
              });
            },
            value: this.state.filterValues[filter.id],
            onResultSelect: function onResultSelect(selected) {
              if (!selected) {
                _this2.handleFilterChange(filter.id, undefined);
              } else {
                _this2.handleFilterChange(filter.id, selected.value);
              }
            },
            isLoading: filter.isLoading,
            clearable: true
          }));

        case 'multipicklist':
          return /*#__PURE__*/_react.default.createElement("div", {
            key: filter.id,
            className: "fd__field__multi"
          }, /*#__PURE__*/_react.default.createElement(_MultiPickList.default, {
            isMulti: true,
            name: filter.id,
            label: filter.title || filter.label,
            listOptions: filter.options,
            clearable: false,
            value: this.state.multiSelectValues,
            placeholder: "Please select . . .",
            onResultSelect: function onResultSelect(selected) {
              _this2.handleMultiChange(filter.id, selected);
            },
            closeMenuOnSelect: false,
            hideSelectedOptions: false
          }));

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          filters = _this$props.filters,
          resultsMessage = _this$props.resultsMessage,
          sortCriteria = _this$props.sortCriteria;
      var classes = (0, _classnames.default)('filter-panel');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, resultsMessage && /*#__PURE__*/_react.default.createElement("div", {
        className: "results-message"
      }, resultsMessage), /*#__PURE__*/_react.default.createElement("div", {
        className: "panel-bar"
      }, filters && /*#__PURE__*/_react.default.createElement(_FilterDropdown.default, {
        id: "filter-results-dropdown",
        ref: function ref(node) {
          return _this3.filterDropdownRef = node;
        },
        toggleLabel: "Filter results",
        isOpen: this.state.isFiltersOpen
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleApplyFilters
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "fd__panel-fields"
      }, (filters || []).map(function (filter) {
        return _this3._renderFilterField(filter);
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "fd__panel-buttons btn-holder"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "button",
        variant: _Button.default.Variant.SECONDARY,
        onClick: this.handleClearFilters
      }, "Clear filters"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit"
      }, "Apply filters")))), sortCriteria && /*#__PURE__*/_react.default.createElement(_FilterDropdown.default, {
        id: "sort-results-dropdown",
        ref: function ref(node) {
          return _this3.sortDropdownRef = node;
        },
        toggleLabel: "Sort results"
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "desktop-filter-sort",
        onSubmit: this.handleApplySort
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        isInline: true,
        className: "desktop-filter-sort__input",
        key: sortCriteria.id,
        name: sortCriteria.id,
        label: sortCriteria.title || sortCriteria.label,
        options: sortCriteria.options,
        value: this.state.sortBy,
        onChange: this.handleSortChange,
        width: "m"
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "desktop-filter-sort__button",
        tag: "button",
        type: "submit",
        variant: _Button.default.Variant.PRIMARY
      }, "Go")))));
    }
  }]);

  return FilterPanel;
}(_react.default.Component);

FilterPanel.defaultProps = {
  onApplySort: function onApplySort() {},
  onApplyFilters: function onApplyFilters() {},
  onClearFilters: function onClearFilters() {},
  resultsMessage: null,
  sortCriteria: null,
  filters: [],
  filterValues: undefined,
  sortBy: undefined
};
FilterPanel.propTypes = {
  onApplySort: _propTypes.default.func,
  onApplyFilters: _propTypes.default.func,
  onClearFilters: _propTypes.default.func,
  resultsMessage: _propTypes.default.node,
  filterValues: _propTypes.default.object,
  sortBy: _propTypes.default.string,
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.node,
    type: _propTypes.default.oneOf(['radio', 'checkbox', 'picklist', 'multipicklist']),
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    }))
  })),
  sortCriteria: _propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    label: _propTypes.default.node,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    }))
  })
};
var _default = FilterPanel;
exports.default = _default;
//# sourceMappingURL=FilterPanel.js.map